<template>
  <div v-if="calcPv() >= 0" class="step-1-page">
    <div class="data__start-date" v-if="showStartDatePicker">
      <date-picker v-if="showStartDatePicker"
                   :style="{'left': '28%', 'top':'5px'}"
                   :value="startDate"
                   :isShowTimezone="true"
                   :isShowTimezoneValue="true"
                   :minDate="minStartDate"
                   :maxDate="maxStartDate"
                   :timezone="timezone"
                   :timezoneName="timezoneName"
                   :isFromNow="startDate === null ? true : false"
                   @input="onCalendarDateChange('startDate', $event)"
                   @onCloseClick="showStartDatePicker = false"/>
    </div>
    <div class="data__end-date" v-if="showEndDatePicker">
      <date-picker v-if="showEndDatePicker"
                   :value="endDate"
                   :style="{'top':'5px'}"
                   :minDate="minEndDate"
                   :isShowTimezone="true"
                   :isShowTimezoneValue="true"
                   :timezone="timezone"
                   :timezoneName="timezoneName"
                   :isEndless="endDate ? false : true"
                   @input="onCalendarDateChange('endDate', $event)"
                   @onCloseClick="showEndDatePicker = false"/>
    </div>
    <div class="over-btn">
      <div class="header-block">
        <div class="insert-subject">
          {{ $t('heatmap.registration.subject') }} 1 / 2
        </div>

        <div class="tracking-code">
          <span>
          {{ $t('heatmap.registration.trackingCode') }}
          </span>
          <button class="code-check" @click="$emit('codeCheck', url)">
            <i class="icon icon--arrow-right-blue-xsmall"></i>
            <span>{{ $t('heatmap.registration.codeCheck') }}</span>
          </button>
        </div>

        <div class="url" ref="urlBox">
          {{ listUrl }}
        </div>
      </div>
      <div class="content-block">
        <div class="date-block">
          <div class="date-wrap">
            <div class="date-subject">
              {{ $t('heatmap.registration.dateSubject') }}
            </div>
            <div class="date_picker_input--wrap">
              <div class="datepicker--wrap data__start-date">
                <span class="date_picker_input">
                  <i class="icon icon--calendar-input"></i>
                  <input type="text"
                    :value="startDateStr"
                    :style="isEditMode && getDisalbedStartDate  ? {'background-color': '#E6E6E6'} : {}"
                    :disabled="isEditMode && getDisalbedStartDate ? true : false"
                    @click.stop.prevent="toggleDatePicker('start')"
                    readonly>
                </span>

              </div>
              <span :style="{'padding': '10px 5px 0px 5px'}"> ~ </span>
              <div class="datepicker--wrap data__end-date">
                <span class="date_picker_input">
                  <i class="icon icon--calendar-input"></i>
                  <input type="text" :value="endDateStr"  @click.stop.prevent="toggleDatePicker('end')" readonly >
                </span>

              </div>
            </div>
          </div>
          <div class="date-diff-wrap">
            <div v-if="endDate===null" class="date-diff endless">
              {{ $t('heatmap.registration.endlessComment.first') }}
            </div>
            <div v-else-if="expectedPv === 0" class="date-diff noExpected">
              {{ calcDayDiff }}
            </div>
            <div v-else class="date-diff">
              {{ calcDayDiff }}
            </div>
            <div v-if="endDate!==null && expectedPv !== 0" class="jam-under-date">
              <p v-html="$t('heatmap.registration.jamComment.expected', {pv: convertThousand(expectedPv), jam: convertThousand(calcJam)})"></p>
              <ui-icon-tooltip class="pv-tooltip"
                        :iconSize="'outline-white'"
                        arrowRightSide>
              <span v-html="$t('heatmap.registration.tooltip.expectPV')"></span>
              </ui-icon-tooltip>
            </div>
          </div>
        </div>
        <div class="jam-block">
          <div class="decription-block">
            <div class="jam-basket" :class="{'none-jam-comment': jamCount !== 0 && jamCount >= calcJam }">
              {{ $t('heatmap.registration.jamBasket') }}
              <ui-icon-tooltip :iconSize="'outline-white'"
                        :style="{'margin': '1px 10px 0px 5px', 'vertical-align': 'middle'}"
                        arrowBottom
                        arrowCenter>
              <span v-html="$t('heatmap.registration.tooltip.jamBasket')"></span>
              </ui-icon-tooltip>
              <span class="remainJam-zero" v-if="jamCount === 0">
              {{ jamCount }} JAM
              </span>
              <span v-else class="remainJam-zero" :class="{'none-zero': jamCount !== 0}">
                {{ jamCount }} JAM
              </span>
              <i :style="{'position': 'absolute', 'top': '-3px'}" class="icon icon--jam--24px"></i>
            </div>
            <div class="jam-comment" :class="{deactive: jamCount !== 0 && jamCount >= calcJam && heatmapCount == 0}">
              <span class="remainJam-zero" v-if="jamCount === 0" :style="{'display': 'flex'}">
                <i class="icon icon--info-dot" :class="{red: jamCount === 0}" :style="{'margin-top': '8px'}"></i>
                <div>
                {{ $t('heatmap.registration.jamComment.zeroJam') }}
                </div>
              </span>
              <span v-else-if="jamCount !== 0 && jamCount < calcJam">
                {{ $t('heatmap.registration.jamComment.moreNeedJam') }}
              </span>
              <span v-if="heatmapCount > 0" :style="{'display': 'flex'}">
                <i class="icon icon--info-dot" :style="{'margin-top': '8px'}"></i>
                <div>
                {{ $t('heatmap.registration.jamComment.otherHeatmap', {heatmapCount: heatmapCount}) }}
                </div>
              </span>
            </div>
          </div>
          <div class="jam-btn-block">
            <div v-if="jamCount === 0 || jamCount < calcJam " class="btn">
              <ui-button class="btn-item" :primary2="true" :buttonType="'reset'" @click="onShift">
                {{ $t('common.chargeJam') }}
              </ui-button>
            </div>
            <div v-else class="btn">
              <ui-button  class="btn-item" :buttonType="'reset'" @click="onShift">
                {{ $t('common.chargeJam') }}
              </ui-button>
            </div>
          </div>
          <!-- <dimmed v-if="isShiftJam" :style="{'border-radius': '14px'}">
            <shift-jam
              @isShiftJam="isShiftJam = $event"
              @moveJam="moveJam"
              @isChargingJam="isChargingJamEmit"
              :heatmapJam="jamCount"
              :remainJam="remainJam">
            </shift-jam>
          </dimmed> -->
        </div>
      </div>
    </div>
    <div v-if="isEditMode" class="btn-wrap-edit">
      <ui-button class="btn-item" v-if="cancelScheduleBtn"
        :buttonType="'reset'"
        @click="cancelSchedule">
        {{ $t('heatmap.registration.cancelButton') }}
      </ui-button>
      <ui-button class="btn-confirm custom"
        :size="'large'"
        :primary2="true"
        :disabled="editModeBtn"
        :style="cancelScheduleBtn ? {} : {'margin-left': '240px'}"
        :buttonType="'submit'"
        @click="nextStep">
        {{ $t('common.next') }}
        <i class="icon icon--arrow-right-red"></i>
      </ui-button>
      <ui-button class="btn-confirm"
        :iconName="'icon--check-white-size16'"
        :size="'large'"
        :buttonType="'submit'"
        :disabled="editModeBtn"
        :primary="true"
        @click="register()">
        {{ $t('heatmap.registration.edit') }}
      </ui-button>
    </div>
    <div v-else class="btn-wrap">
      <ui-button class="btn-confirm custom"
        :size="'large'"
        :primary2="true"
        :disabled="jamCount===0"
        :buttonType="'submit'"
        @click="nextStep">
        {{ $t('common.next') }}
        <i class="icon icon--arrow-right-red"></i>
      </ui-button>
    </div>
  </div>
</template>

<script>
import UiButton from '@/components/ui/UiButton'
import UiIconTooltip from '@/components/ui/UiIconTooltip'
import DatePicker from '@/components/date-picker'
import { utcToLocalTimezone, thousand } from '@/libs/utils'
import { format, parse, addDays, startOfDay, endOfDay, differenceInWeeks, differenceInDays } from 'date-fns'
import { DEFAULT_TIMEZONE, DEFAULT_TIMEZONE_NAME, DATE_FORAMT, HEATMAP_STATE } from '@/libs/constants'
import { checkMoveToMyJam } from '@/api/heatmap'

export default {
  name: 'HeatmapRegistrationStep1',
  components: {
    UiButton,
    UiIconTooltip,
    DatePicker
  },
  data () {
    return {
      startDate: this.getStartDate(),
      endDate: this.getEndDate(),
      showStartDatePicker: false,
      showEndDatePicker: false,
      weekDiff: 0,
      isShiftJam: false,
      expectedPv: null,
      heatmapCount: 0
    }
  },
  props: {
    url: {
      default: ''
    },
    listUrl: {
      default: ''
    },
    heightDiff: {
      default: 0
    },
    jamCount: {
      default: 0
    },
    isEditMode: {
      default: false
    },
    model: {
      default: {}
    },
    timezone: {
      default: DEFAULT_TIMEZONE
    },
    timezoneName: {
      default: DEFAULT_TIMEZONE_NAME
    },
    remainJam: {
      default: 0
    },
    pvData: {
      default: {}
    },
    originModel: {
      default: {}
    }
  },
  created () {
    checkMoveToMyJam(true).then((resp) => {
      if (this.originModel && this.originModel.state === 'run') {
        this.heatmapCount = resp.count - 1
      } else {
        this.heatmapCount = resp.count
      }
    })
  },
  computed: {
    getDisalbedStartDate () {
      if (new Date(this.originModel.startDate) < new Date()) {
        if (this.originModel.uiState === HEATMAP_STATE.ENDBYANALYSISDATE) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    editModeBtn () {
      let result
      let startResult
      let endResult
      if (this.jamCount === 0) {
        if (format(this.startDate, DATE_FORAMT) >= format(this.originModel.startDate, DATE_FORAMT)) {
          startResult = false
        } else {
          startResult = true
        }

        if (this.endDate && this.originModel.endDate) {
          if (format(this.endDate, DATE_FORAMT) <= format(this.originModel.endDate, DATE_FORAMT)) {
            endResult = false
          } else {
            endResult = true
          }
        } else {
          if (this.endDate === null && !!this.originModel.endDate) {
            endResult = true
          } else if (this.originModel.endDate === null && !!this.endDate) {
            endResult = false
          }
        }
        result = startResult || endResult
      } else {
        result = false
      }
      return result
    },
    cancelScheduleBtn () {
      if (new Date(this.originModel.startDate) > startOfDay(new Date())) {
        return true
      } else {
        return false
      }
    },
    calcJam () {
      return Math.ceil(this.expectedPv / 1000)
    },
    minEndDate () {
      const now = utcToLocalTimezone(new Date(), this.timezoneName)
      if (this.startDate && parse(this.startDate) < parse(now)) {
        return now
      } else if (!this.startDate) {
        return now
      } else {
        return parse(this.startDate)
      }
    },
    minStartDate () {
      return addDays(utcToLocalTimezone(new Date(), this.timezoneName), 1)
    },
    maxStartDate () {
      if (!this.endDate) {
        return null
      }
      return parse(this.endDate)
    },
    startDateStr () {
      if (this.startDate) {
        return this.startDate
      } else {
        return format(utcToLocalTimezone(new Date(), this.timezoneName), DATE_FORAMT)
      }
    },
    endDateStr () {
      if (this.endDate) {
        return this.endDate
      } else if (this.endDate === null) {
        return this.$t('common.nonStop')
      } else {
        return this.$t('common.placeHolder.endDate')
      }
    },
    calcWeekDiff () {
      const weekDiff = this.weekDiffCalc()
      if (weekDiff) {
        return `${weekDiff} weeks`
      } else {
        return ''
      }
    },
    calcDayDiff () {
      const endDate = this.endDate
      const startDate = format(this.startDate ? this.startDate : utcToLocalTimezone(new Date(), this.timezoneName), DATE_FORAMT)
      const dayDiff = differenceInDays(endDate, startDate) + 1
      let calcDayDiff = dayDiff % 7
      let calcWeekDiff = Math.floor(dayDiff / 7)
      let result = ''
      if (calcWeekDiff) {
        if (calcWeekDiff === 1) {
          result += `${calcWeekDiff} week`
        } else if (calcWeekDiff > 1) {
          result += `${calcWeekDiff} weeks`
        }
      }
      if (calcDayDiff) {
        result += ` ${calcDayDiff} days`
      }
      return result
    }
  },
  methods: {
    calcPv () {
      let avg
      if (this.pvData) {
        if (this.pvData.total > 0) {
          if (this.endDate === null) {
            this.expectedPv = 0
            return this.expectedPv
          } else {
            const endDate = format(new Date(this.endDate), DATE_FORAMT)
            const startDate = format(this.startDate ? new Date(this.startDate) : utcToLocalTimezone(new Date(), this.timezoneName), DATE_FORAMT)
            const dayDiff = differenceInDays(endDate, startDate) + 1
            avg = this.pvData.total / this.pvData.validDate
            this.expectedPv = Math.round(avg * dayDiff)
            return this.expectedPv
          }
        } else {
          this.expectedPv = 0
          return this.expectedPv
        }
      } else {
        this.expectedPv = 0
        return this.expectedPv
      }
    },
    convertThousand (value) {
      return thousand(value)
    },
    onShift () {
      this.$emit('isShiftJam', this.jamCount, this.remainJam)
    },
    cancelSchedule () {
      this.$emit('cancelSchedule')
    },
    getStartDate () {
      if (this.isEditMode) {
        if (this.originModel.uiState === 'endByAnalysisDate') {
          return null
        } else {
          return format(utcToLocalTimezone(this.model.startDate, this.timezoneName), DATE_FORAMT)
        }
      } else {
        return null
      }
    },
    getEndDate () {
      if (this.isEditMode) {
        if (this.originModel.uiState === 'endByAnalysisDate') {
          return format(addDays(utcToLocalTimezone(new Date(), this.timezoneName), 6), DATE_FORAMT)
        } else {
          if (this.model.endDate) {
            return format(utcToLocalTimezone(this.model.endDate, this.timezoneName), DATE_FORAMT)
          } else {
            return null
          }
        }
      } else {
        return format(addDays(utcToLocalTimezone(new Date(), this.timezoneName), 6), DATE_FORAMT)
      }
    },
    weekDiffCalc  () {
      const endDate = new Date(this.endDate)
      const startDate = new Date(this.startDate)
      const weekDiff = differenceInWeeks(endDate, startDate)
      this.weekDiff = weekDiff
      return this.weekDiff
    },
    register () {
      this.model.startDate = this.startDate
      this.model.endDate = this.endDate
      this.$emit('register', this.model)
    },
    nextStep () {
      this.model.startDate = this.startDate
      this.model.endDate = this.endDate
      this.$emit('nextStep', this.model)
    },
    onCalendarDateChange (dateType, value) {
      if (dateType === 'endDate' && value === null) {
        this.endDate = value
        return
      } else if (dateType === 'startDate' && value === null) {
        this.startDate = value
        return
      }
      let dateValue = parse(value)

      if (dateType === 'startDate') {
        dateValue = startOfDay(dateValue)
      } else {
        dateValue = endOfDay(dateValue)
      }
      dateValue = format(dateValue, DATE_FORAMT)
      if (dateType === 'startDate') {
        this.startDate = dateValue
      } else {
        this.endDate = dateValue
      }
    },
    toggleDatePicker (type) {
      switch (type) {
        case 'start':
          this.showStartDatePicker = !this.showStartDatePicker
          this.showEndDatePicker = false
          break
        case 'end':
          this.showEndDatePicker = !this.showEndDatePicker
          this.showStartDatePicker = false
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.step-1-page {
  height: inherit;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .over-btn {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding-bottom: 30px;
    padding-right: 27px;
    margin-bottom: 15px;
    --scrollbar-width: 8px;
    --mask-height: 40px;
    --mask-image-content: linear-gradient(
        to bottom,
        black var(--mask-height),
        black calc(100% - var(--mask-height)),
        transparent
    );

    --mask-size-content: calc(100% - var(--scrollbar-width)) 100%;
    --mask-image-scrollbar: linear-gradient(black, black);
    --mask-size-scrollbar: var(--scrollbar-width) 100%;
    mask-image: var(--mask-image-content), var(--mask-image-scrollbar);
    mask-size: var(--mask-size-content), var(--mask-size-scrollbar);
    mask-position: 0 0, 100% 0;
    mask-repeat: no-repeat, no-repeat;

    .header-block {
      text-align: left;
      border-bottom: dashed 1px #c1c1c1;
      border-color: #c1c1c1;
      .insert-subject {
        color: #2F2F2F;
        margin-bottom: 5px;
        font-size: 15px;
        font-style: normal;
        font-weight: 500;
        line-height: 15px; /* 100% */
      }
      .tracking-code {
        & span {
          color: #767676;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
          display: inline-block;
          margin-bottom: 23px;
        }

        .code-check {
          position: relative;
          margin-left: 8px;

          & .icon {
            position: absolute;
            top: 50%;
            transform: translate(0, -50%);
          }

          & span {
            position: relative;
            color: #0074FF;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px;
            margin: 0 0 0 15px;
          }
        }
      }
      .url {
        color: #767676;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 183.333% */
        margin-bottom: 10px;
        word-break: break-all;
      }
    }
    .content-block {
      margin-top: 36px;
      .date-block {
        display: flex;
        justify-content: space-between;
        .date-wrap {
          text-align: left;
          .date-subject {
            color: #767676;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 19px; /* 135.714% */
            margin-bottom: 10px;
          }
          .date_picker_input--wrap {
            display: flex;

            .date_picker_input {
              position: relative;
              width: 130px;
              height: 38px;

              input {
                text-indent: 35px;
                display: inline-block;
                width: 130px;
                height: 38px;
                border-radius: 6px;
                border: solid 1px #bbbbbb;
                background-color: #ffffff;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                font-size: 14px;
                color: #999999;
              }
              .icon--calendar-input {
                position: absolute;
                top: 50%;
                left: 10px;
                transform: translateY(-50%);
              }
            }
          }
        }
        .date-diff-wrap {
          text-align: right;

          .date-diff {
            color: #7F00FF;
            font-size: 32px;
            font-style: normal;
            font-weight: 500;
            line-height: 35px; /* 109.375% */
            &.endless {
              margin-top: 36px;
              color: #7F00FF;
              text-align: right;
              font-size: 17px;
              font-style: normal;
              font-weight: 500;
              line-height: 23px; /* 127.778% */
            }
            &.noExpected {
              margin-top: 34px;
              color: #7F00FF;
              text-align: right;
              font-size: 32px;
              font-style: normal;
              font-weight: 500;
              line-height: 23px; /* 127.778% */
            }
          }
          .jam-under-date {
            margin-top: 7px;
            color: #444;
            font-size: 13px;
            font-style: normal;
            font-weight: 400;
            line-height: 19px; /* 146.154% */

            & /deep/ .tooltip {
              margin-top: 3px;
              & .bubble {
                inset: auto auto -13px -292px
              }
            }
          }
        }
      }
      .jam-block {
        display: flex;
        justify-content: space-between;
        border-radius: 5px;
        border: 1px solid #d7d7d7;
        background-color: #f4f4f4;
        box-sizing: border-box;
        min-height: 114px;
        margin-top: 26px;
        padding: 20px;
        .decription-block {
          text-align: left;
          .jam-basket {
            margin-top: 6px;
            color: #2F2F2F;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            position: relative;
            &.none-jam-comment {

            }
          }
          .remainJam-zero {
            color: #EC0047;
            &.none-zero {
              color: #FF5B8C;
              font-size: 14px;
              font-style: normal;
              font-weight: 500;
              line-height: normal;
            }
          }
          .icon--jam--24px {
            margin-left: 5px;
          }
          .jam-comment {
            align-items: center;
            margin-top: 13px;
            color: #2F2F2F;
            font-size: 13px;
            font-style: normal;
            font-weight: 400;
            max-width: 400px;
            line-height: 19px; /* 146.154% */
            &.deactive {
              margin-top: 0px;
            }
            .icon {
              margin-right: 5px;
            }
          }
        }
        .jam-btn-block {
          display: table;
          height: inherit;
          .btn {
            display: table-cell;
            vertical-align: middle;
          }
        }
      }
    }
  }
  .btn-wrap-edit {
    display: flex;
    width: 100%;
    left: 0;
    bottom: -92px;
    justify-content: space-between;
    .custom {
      padding-left: 25px;
      padding-right: 13px;
      min-width: initial;

      & /deep/ .text {
        vertical-align: middle;
        line-height: 38px;

        & .icon {
          vertical-align: middle;
          top: -2px;
          display: inline-block;
          position: relative;
          margin-left: 5px;
        }
      }

      &:hover {
        & /deep/ .icon {
          background-image: url(../../assets/img/common/icon--arrow-right-white.svg);
        }
      }
    }
  }
  .btn-wrap {
    display: inline-block;
    width: 100%;
    .custom {
      padding-left: 25px;
      padding-right: 13px;
      min-width: initial;

      & /deep/ .text {
        vertical-align: middle;
        line-height: 38px;

        & .icon {
          vertical-align: middle;
          top: -2px;
          display: inline-block;
          position: relative;
          margin-left: 5px;
        }
      }

      &:hover {
        & /deep/ .icon {
          background-image: url(../../assets/img/common/icon--arrow-right-white.svg);
        }
      }
    }
  }
}

</style>
